import { Controller } from "@hotwired/stimulus";

// Searchable Fomantic icon picker.
// - Renders icons from data-icons-value (array of dot-key names).
// - Live filter via the search input.
// - Click an icon → updates hidden input + selected state.
//   The current selection auto-scrolls into view when shown.
export default class extends Controller {
  static targets = ["search", "grid", "input", "empty"];
  static values = {
    icons: Array,
    selected: String,
  };

  connect() {
    this.render(this.iconsValue, this.selectedValue);
  }

  filter() {
    const q = (this.searchTarget.value || "").trim().toLowerCase();
    const matches = q
      ? this.iconsValue.filter((name) => name.toLowerCase().includes(q))
      : this.iconsValue;
    this.render(matches, this.selectedValue);
  }

  pick(event) {
    const name = event.currentTarget.dataset.icon;
    this.selectedValue = name;
    if (this.hasInputTarget) this.inputTarget.value = name;
    this.gridTarget
      .querySelectorAll("[data-role='icon-option']")
      .forEach((b) =>
        b.classList.toggle("is-selected", b.dataset.icon === name)
      );
  }

  render(list, selected) {
    if (list.length === 0) {
      this.gridTarget.innerHTML = "";
      if (this.hasEmptyTarget) this.emptyTarget.hidden = false;
      return;
    }
    if (this.hasEmptyTarget) this.emptyTarget.hidden = true;

    this.gridTarget.innerHTML = list
      .map(
        (name) =>
          `<button type="button" class="creator-list-form__icon-option${
            name === selected ? " is-selected" : ""
          }" data-icon="${name}" data-role="icon-option" title="${name.replace(
            /\./g,
            " "
          )}" data-action="click->icon-picker#pick"><i class="icon ${name.replace(
            /\./g,
            " "
          )}"></i></button>`
      )
      .join("");

    // Auto-scroll to selected.
    const sel = this.gridTarget.querySelector(".is-selected");
    if (sel?.scrollIntoView) sel.scrollIntoView({ block: "center" });
  }
}
